import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isNullOrUndefinedOrEmpty } from '../../../../../../../../helpers/common';
import { propArrayShape } from '../../../../../../../../helpers/custom-prop-types';
import ProfessionalMyPageTopProffitSearchSlideTagsEmpty from './ProffitSearchSlideTagsContentEmpty';
import ProfessionalMyPageTopProffitSearchSlideTagsList from './ProffitSearchSlideTagsContentList';
import ProfessionalMyPageTopProffitSearchSlideTagsSkeleton from './ProffitSearchSlideTagsContentSkeleton';
/**
 * 読み込み状況に応じてPrpffit Searchの人気タグを出しわけするコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchSlideTagsContent = (props) => {
    const { tags } = props;
    if (isNullOrUndefinedOrEmpty(tags)) {
        return _jsx(ProfessionalMyPageTopProffitSearchSlideTagsSkeleton, {});
    }
    if (!tags.length) {
        return _jsx(ProfessionalMyPageTopProffitSearchSlideTagsEmpty, {});
    }
    return _jsx(ProfessionalMyPageTopProffitSearchSlideTagsList, { tags: tags });
};
ProfessionalMyPageTopProffitSearchSlideTagsContent.propTypes = {
    tags: propArrayShape(),
};
ProfessionalMyPageTopProffitSearchSlideTagsContent.defaultProps = {
    tags: null,
};
export default ProfessionalMyPageTopProffitSearchSlideTagsContent;
